(function () {
  'use strict';

  if (window.__zvAsideMenuReady) return;
  window.__zvAsideMenuReady = true;

  const MENU_SELECTOR = '[data-zv-aside-menu]';
  const OPEN_TRIGGER_SELECTOR = [
    '[data-zv-aside-open]',
    '.header__offcanvas-toggle.aside-menu__toggle--open-btn',
    '.header__offcanvas-toggle.aside-menu__toggle--open',
    'button.aside-menu__toggle--open-btn',
    'button.aside-menu__toggle--open',
    'summary.header__icon--menu',
    '.header__icon--menu',
    'header-drawer summary.header__icon--menu',
    '.header-drawer summary.header__icon--menu'
  ].join(', ');
  const CLOSE_TRIGGER_SELECTOR = '[data-zv-aside-close], .aside-menu__close';
  const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), summary, input, textarea, select, [tabindex]:not([tabindex="-1"])';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastFocused = null;

  function getMenu() {
    return document.querySelector(MENU_SELECTOR);
  }

  function getOpenTriggers() {
    return [...document.querySelectorAll(OPEN_TRIGGER_SELECTOR)].filter((trigger) => !trigger.closest(MENU_SELECTOR));
  }

  function setBodyLock(locked) {
    document.documentElement.classList.toggle('zv-aside-menu-open', locked);
    document.body.classList.toggle('zv-aside-menu-open', locked);
    document.body.classList.toggle('overflow-hidden-drawer', locked);
  }

  function setTriggerState(open) {
    getOpenTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));
  }

  function loadDeferredImages(menu) {
    if (!menu) return;

    menu.querySelectorAll('img[data-zv-deferred-image]').forEach((image) => {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-zv-deferred-image');
    });
  }

  function closeNativeDrawer() {
    document.querySelectorAll('header-drawer details[open], menu-drawer details[open], details.menu-drawer-container[open]').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });

    document.querySelectorAll("summary.header__icon--menu[aria-expanded='true'], .header__icon--menu[aria-expanded='true']").forEach((summary) => {
      summary.setAttribute('aria-expanded', 'false');
    });
  }

  function animateGroup(group, open) {
    if (!group) return;

    const duration = reducedMotion.matches ? 0 : 280;
    window.clearTimeout(Number(group.dataset.zvCloseTimer || 0));

    if (open) {
      group.setAttribute('open', '');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => group.classList.add('is-open'));
      });
      return;
    }

    group.classList.remove('is-open');
    const timer = window.setTimeout(() => group.removeAttribute('open'), duration);
    group.dataset.zvCloseTimer = String(timer);
  }

  function closeSiblingGroups(activeGroup) {
    const menu = getMenu();
    if (!menu) return;

    menu.querySelectorAll('[data-zv-menu-group][open]').forEach((group) => {
      if (group !== activeGroup) animateGroup(group, false);
    });
  }

  function initGroups(menu) {
    menu.querySelectorAll('[data-zv-menu-group]').forEach((group) => {
      if (group.dataset.zvGroupReady === 'true') return;
      group.dataset.zvGroupReady = 'true';

      if (group.open) group.classList.add('is-open');

      const summary = group.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const willOpen = !group.open || !group.classList.contains('is-open');

        if (willOpen) closeSiblingGroups(group);
        animateGroup(group, willOpen);
      });
    });
  }

  function openMenu(event) {
    const menu = getMenu();
    if (!menu) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }

    lastFocused = document.activeElement;
    closeNativeDrawer();
    loadDeferredImages(menu);

    menu.classList.add('aside-menu--open');
    menu.setAttribute('aria-hidden', 'false');
    setBodyLock(true);
    setTriggerState(true);

    const scrollArea = menu.querySelector('[data-zv-aside-scroll]');
    if (scrollArea) scrollArea.scrollTop = 0;

    const header = document.querySelector('.header-wrapper');
    if (header) header.preventHide = true;

    window.setTimeout(() => {
      const closeButton = menu.querySelector('.aside-menu__close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }, reducedMotion.matches ? 0 : 80);
  }

  function closeMenu(event) {
    const menu = getMenu();
    if (!menu) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    menu.classList.remove('aside-menu--open');
    menu.setAttribute('aria-hidden', 'true');
    setBodyLock(false);
    setTriggerState(false);
    closeNativeDrawer();

    const header = document.querySelector('.header-wrapper');
    if (header) header.preventHide = false;

    window.setTimeout(() => {
      menu.querySelectorAll('[data-zv-menu-group][open]').forEach((group) => animateGroup(group, false));
    }, reducedMotion.matches ? 0 : 340);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      window.setTimeout(() => lastFocused.focus({ preventScroll: true }), reducedMotion.matches ? 0 : 70);
    }
  }

  function visibleFocusable(menu) {
    return [...menu.querySelectorAll(FOCUSABLE_SELECTOR)].filter((element) => element.offsetParent !== null || element === document.activeElement);
  }

  function openAdvicePopup(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    closeMenu();

    window.setTimeout(() => {
      const desktopTrigger = [...document.querySelectorAll('a[href="#zv-advies-popup"]')]
        .find((element) => !element.closest(MENU_SELECTOR));

      if (desktopTrigger) {
        desktopTrigger.click();
        return;
      }

      const popup = document.querySelector('#zv-advies-popup');
      if (popup) {
        window.location.hash = 'zv-advies-popup';
      }
    }, reducedMotion.matches ? 0 : 360);
  }

  function handleClick(event) {
    const adviceTrigger = event.target.closest && event.target.closest('[data-zv-advice-popup]');
    if (adviceTrigger && adviceTrigger.closest(MENU_SELECTOR)) {
      openAdvicePopup(event);
      return;
    }

    const openTrigger = event.target.closest && event.target.closest(OPEN_TRIGGER_SELECTOR);
    if (openTrigger && !openTrigger.closest(MENU_SELECTOR)) {
      openMenu(event);
      return;
    }

    const closeTrigger = event.target.closest && event.target.closest(CLOSE_TRIGGER_SELECTOR);
    if (closeTrigger) {
      closeMenu(event);
      return;
    }

    const menu = getMenu();
    const navigationLink = event.target.closest && event.target.closest(`${MENU_SELECTOR} a[href]`);
    if (menu && navigationLink && !navigationLink.getAttribute('href').startsWith('#')) {
      window.setTimeout(() => closeMenu(), 30);
    }
  }

  function handleKeydown(event) {
    const menu = getMenu();
    if (!menu || !menu.classList.contains('aside-menu--open')) return;

    if (event.key === 'Escape') {
      closeMenu(event);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = visibleFocusable(menu);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initialize() {
    const menu = getMenu();
    if (!menu) return;

    initGroups(menu);
    menu.setAttribute('aria-hidden', menu.classList.contains('aside-menu--open') ? 'false' : 'true');
    setTriggerState(menu.classList.contains('aside-menu--open'));
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:reorder', initialize);

  initialize();

  window.zvOpenAsideMenu = openMenu;
  window.zvCloseAsideMenu = closeMenu;
})();
